<template>
  <TableList
    class="upload-task-history-list"
    no-operation
    :list-data="taskHistoryList"
    :table-columns="tableColumns"
    :showCreateBtn="false"
  >
    <template #filter-group>
      <span @click="fetchUploadTaskHistory">{{ $t(`${i18nPrefix}.containerTitle.uploadHistory`) }}</span>
      <el-button type="primary" class="refresh-btn" @click="fetchUploadTaskHistory">{{ $t('common.btn.refresh') }}</el-button>
    </template>
    <template #viewBtnGroup="{ row }">
      <el-button v-show="row.candidate_id" type="text" @click="handleViewCandidateBtnClick(row)">{{ $t(`${i18nPrefix}.btn.viewCandidate`) }}</el-button>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/noBorderTable.vue'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.application.batchUpload',
      taskHistoryList: []
    }
  },
  computed: {
    jobId () {
      return this.$route.params.jobId
    },
    tableColumns () {
      const columns = [
        {
          width: '300px',
          cellClass: 'file-name',
          label: this.$t(`${this.i18nPrefix}.label.fileName`),
          dataKey: 'file_name'
        },
        {
          width: '120px',
          label: this.$t(`${this.i18nPrefix}.label.startTime`),
          dataKey: 'start_time',
          formatter: (data) => {
            return data ? moment(data).format('YYYY/MM/DD') : ''
          }
        },
        {
          width: '120px',
          label: this.$t(`${this.i18nPrefix}.label.finishTime`),
          dataKey: 'finish_time',
          formatter: (data) => {
            return data ? moment(data).format('YYYY/MM/DD') : ''
          }
        },
        {
          width: '80px',
          label: this.$t(`${this.i18nPrefix}.label.status`),
          dataKey: 'status',
          formatter: (data) => {
            let i18nKey = ''
            if (data.endsWith('_FAIL')) {
              i18nKey = 'FAILED'
            } else if (['FINISHED', 'APPLICATION_EXISTED', 'TALENT_EXISTED'].includes(data)) {
              i18nKey = data
            } else {
              i18nKey = 'WAITING'
            }
            return this.$t(`${this.i18nPrefix}.taskStatus.${i18nKey}`)
          }
        },
        {
          width: '180px',
          label: this.$t(`${this.i18nPrefix}.label.job`),
          dataKey: 'job_id_title',
          hidden: this.jobId !== '-1'
        },
        {
          width: '120px',
          cellClass: 'view-btn-group',
          label: this.$t('common.label.operate'),
          dataKey: 'id',
          slotName: 'viewBtnGroup'
        }
      ]
      return _.filter(columns, item => !item.hidden)
    }
  },
  created () {
    this.fetchUploadTaskHistory()
  },
  methods: {
    ...mapActions('application', ['getUploadTaskHistory']),
    async fetchUploadTaskHistory () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getUploadTaskHistory({ job_id: this.jobId })
        if (resp) {
          _.forEach(resp, item => {
            if (item.job_id) {
              addI18nProperty(item, 'job_title', 'job_cn_title', 'job_en_title')
              Object.defineProperty(item, 'job_id_title', {
                enumerable: true,
                configurable: true,
                get: function () {
                  return `${item.job_id}-${item.job_title}`
                }
              })
            }
          })
          this.taskHistoryList = resp
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleViewCandidateBtnClick (row) {
      let url
      const back = this.$route.fullPath
      if (row.only_talent_pool) {
        url = `/v-admin/talent-pool/candidate/profile?candidate_id=${row.candidate_id}&back=${back}`
      } else {
        url = `/v-admin/application/profile/resume?candidate_id=${row.candidate_id}&job_id=${row.job_id}&back=${back}`
      }
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-task-history-list {
  $main-color: #6c6c6c;
  padding: 0 10px;

  .empty-list {
    color: $main-color;
    text-align: center;
  }

  .refresh-btn {
    margin-left: auto;
    padding: 6px 20px;
    border-radius: 4px;
  }

  ::v-deep {
    .table-header {
      height: auto;
      margin-bottom: 22px;
      margin-top: 0;

      .filter-group {
        margin: 0;
        font-size: 18px;
      }
    }

    .table-container {
      .el-table {
        overflow: initial;

        .el-table__header-wrapper {
          .el-table__cell {
            text-align: left;
            font-size: 14px;
            .cell {
              padding: 0 10px;
            }
          }
        }

        .el-table__body-wrapper {
          padding: 0 0 10px 0;
          overflow: initial;

          .el-table__cell {
            border-bottom: 1px solid #DFDFDF;
            text-align: left;
            font-size: 14px;
            .cell {
              padding: 0 10px;
              .el-button {
                font-size: 14px;
              }
            }
          }
        }
      }
    }

    .el-table__header th.el-table__cell {
      background-color: #FAFAFA;
    }

    td.file-name {
      text-align: left;
    }

    td.view-btn-group {
      .cell {
        padding: 10px 0;

        .el-button {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
  }
}
</style>
